// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DlQXvgZCg3wd2P0nzHlZ{flex-direction:column;gap:8px;padding:26px 15px 15px;display:flex;position:relative}.ZzdBlCnfHYsZrVcWQcVz{align-items:center;gap:4px;padding-left:8px;padding-right:4px;display:flex;position:absolute;top:0;bottom:0;right:0}.CznNcDD_IRMV0GEgrKZ9{padding:0 6px 6px}.kyNSVLrDstkqw9BFNxfI{margin-bottom:20px}.kyNSVLrDstkqw9BFNxfI:last-of-type{margin-bottom:0}.ka8kWm_4VJkFuLjYY8m6{color:var(--content-primary-primary)}.w_44_arNkWc96fC0fkKw{align-items:center;gap:6px;margin-bottom:12px;display:flex}.era2DbM63JQdL_0nb37D{background:var(--black-80);border-radius:50%;flex:0 0 16px;justify-content:center;align-items:center;width:16px;height:16px;display:flex}.MDhLbA7xTccILOGXGrVC{background:var(--black-80)}.PVmPdU_yawsMG6pUsG4a{background:var(--black-50)}.CwdAO9M_5YYqQGqE37r5{color:var(--content-primary-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapContent": `DlQXvgZCg3wd2P0nzHlZ`,
	"actions": `ZzdBlCnfHYsZrVcWQcVz`,
	"content": `CznNcDD_IRMV0GEgrKZ9`,
	"card": `kyNSVLrDstkqw9BFNxfI`,
	"card__text": `ka8kWm_4VJkFuLjYY8m6`,
	"cardText": `ka8kWm_4VJkFuLjYY8m6`,
	"cardTitle": `w_44_arNkWc96fC0fkKw`,
	"cardTitle__count": `era2DbM63JQdL_0nb37D`,
	"cardTitleCount": `era2DbM63JQdL_0nb37D`,
	"cardTitle__count__one": `MDhLbA7xTccILOGXGrVC`,
	"cardTitleCountOne": `MDhLbA7xTccILOGXGrVC`,
	"cardTitle__count__two": `PVmPdU_yawsMG6pUsG4a`,
	"cardTitleCountTwo": `PVmPdU_yawsMG6pUsG4a`,
	"cardTitle__text": `CwdAO9M_5YYqQGqE37r5`,
	"cardTitleText": `CwdAO9M_5YYqQGqE37r5`
};
export default ___CSS_LOADER_EXPORT___;
